export default __webpack_public_path__ + "static/icons8-chatbot-3fe2c35a79199491cddfd82d14d30932.gif";